<form [formGroup]="parcelForm">
    <app-attachment-select formControlName="attachment"></app-attachment-select>
</form>
